module.exports = __webpack_public_path__ + "img/free-icon.92efff76.svg";